
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-codeHighlighter.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-code-highlighter-demo-codehighlighter"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-codeHighlighter.en-US.md?type=demo')
};